import { Badge } from '@/components/atoms/badge';
import { cn } from '@/lib/utils';
import type { PayApplicationStatus, ProjectStatus } from '@/types/project';

const PROJECT_STATUS_STYLES: Record<ProjectStatus, string> = {
  PLANNING: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-200',
  ACTIVE: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200',
  ON_HOLD: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  COMPLETED: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
  CLOSED: 'bg-zinc-200 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300',
  CANCELLED: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
};

export const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
  PLANNING: 'Planning',
  ACTIVE: 'Active',
  ON_HOLD: 'On hold',
  COMPLETED: 'Completed',
  CLOSED: 'Closed',
  CANCELLED: 'Cancelled',
};

export function ProjectStatusBadge({ status }: { status: ProjectStatus }) {
  return (
    <Badge variant="outline" className={cn('border-transparent', PROJECT_STATUS_STYLES[status])}>
      {PROJECT_STATUS_LABELS[status] ?? status}
    </Badge>
  );
}

const PAY_APP_STATUS_STYLES: Record<PayApplicationStatus, string> = {
  DRAFT: 'bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300',
  SUBMITTED: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-200',
  APPROVED: 'bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-200',
  INVOICED: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  PAID: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200',
  VOID: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
};

export function PayApplicationStatusBadge({ status }: { status: PayApplicationStatus }) {
  return (
    <Badge variant="outline" className={cn('border-transparent', PAY_APP_STATUS_STYLES[status])}>
      {status}
    </Badge>
  );
}
